var DialogView = require('dialogview');


var ContextMenuView = DialogView.extend({
    initialize: function (options) {
        options = options || {};
        DialogView.prototype.initialize.call(this, options);
        
        this.showInstant = true;
        this.hideInstant = true;
        this.closeOnClickOff = true;
    },
    size: function (x, y) {
        // Reset
        $(this.el).removeClass('contextMenu__top');
        $(this.el).removeClass('contextMenu__bottom');
        $(this.el).removeClass('contextMenu__left');
        $(this.el).removeClass('contextMenu__right');
        this.$('.contextMenu__wrap').css('max-height', 'none');
        
        // Ensure we don't overflow the bottom
        var height = $(this.el).height();
        var windowHeight = $(window).height();
        var bottomPad = 25;
        var maxY = windowHeight - height - bottomPad;
        var css = {};
        var maxHeight;
        if (this.options.anchorBottom) {
            $(this.el).addClass('contextMenu__bottom');
            maxHeight = y - bottomPad;
            css.top = 'inherit';
            css.bottom = windowHeight - y;
        } else {
            if (this.options.anchorBottom === false) {
                $(this.el).addClass('contextMenu__top');
                maxHeight = windowHeight - css.top - bottomPad;
                css.top = y;
            } else {
                if (y > maxY) {
                    $(this.el).addClass('contextMenu__bottom');
                    maxHeight = 'none';
                    css.top = maxY;
                } else {
                    $(this.el).addClass('contextMenu__top');
                    maxHeight = windowHeight - css.top - bottomPad;
                    css.top = y;
                }
            }
            css.bottom = 'inherit';
        }
        
        // Ensure we don't overflow the right hand side
        var width = $(this.el).width();
        var windowWidth = $(window).width();
        var maxX = windowWidth - width;
        if (this.options.anchorRight !== false && (this.options.anchorRight || x > maxX)) {
            css.left = 'inherit';
            css.right = windowWidth - x;
            if (x > maxX) {
                $(this.el).addClass('contextMenu__right');
            } else {
                $(this.el).addClass('contextMenu__left');
            }
        } else {
            css.left = x;
            css.right = 'inherit';
            $(this.el).addClass('contextMenu__left');
        }
        $(this.el).css(css);
        this.$('.contextMenu__wrap').css('max-height', maxHeight);
    },
    show: function (x, y, options) {
        this.options = options || {};
        this.$el.on('reflowImageContainer', _.bind(function () {
            if (this.isVisible()) {
                this.size(x, y);
                this.el.scrollTop = 0;
            }
        }, this));

        this.size(x, y);
        
        DialogView.prototype.show.call(this);
        
        this.el.scrollTop = 0;
    },
    enableItem: function (item, condition) {
        item.toggleClass('enabled', condition);
        item.find('button').attr('aria-pressed', String(condition));
    },
    deactivateItem: function (item, condition, toggle) {
        item.toggleClass('inactive', condition).attr('aria-disabled', String(condition));
        item.find('button').prop('disabled', condition);
        item.find('.contextMenu__item').toggleClass('contextMenu__item--disabled', condition);
        if (toggle) {
            item.toggle(!condition);
        }
    },
    afterShow: function () {
        this.focusFirstItem();
    },
    afterHide: function () {
        this.options = null;
    },
    focusFirstItem: function () {
        if (this.options.keypress) {
            this.$('.contextMenu__item:not(.contextMenu__item--disabled):first').focus();
        }
    }
});


module.exports = ContextMenuView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/contextmenuview.js
// module id = hI2d
// module chunks = 1